import { withStyles } from "@material-ui/core/styles";
import { styles } from "./DateWithOptionEdit.styles";
import React, { useState } from "react";
import { FormControl, FormHelperText, WithStyles } from "@material-ui/core";
import Radio from "@material-ui/core/Radio/Radio";
import { FormDateField } from "../FormComponents/FormDateField";
import RadioGroup from "@material-ui/core/RadioGroup/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import {
    consolidateDateToNumber,
    convertDateStringToNumber,
    mapNumberToDate,
    today
} from "../../../utilities/dateTimeUtils";
import { DATE_FORMAT } from "../../../constants/TIME";

export interface IDateWithOptionEditProps extends WithStyles<typeof styles> {
    value: number | null;
    onChange: (value) => void;
    firstAvailableDate?: number;
    error?: boolean;
    helperText?: string;
    label: string;
}

const DateWithOptionEditPure: React.FunctionComponent<IDateWithOptionEditProps> = ({
    value,
    onChange,
    firstAvailableDate,
    error,
    helperText,
    label
}: IDateWithOptionEditProps) => {
    const [date, setDate] = useState<number>(value || convertDateStringToNumber(today().format(DATE_FORMAT)));

    return (
        <FormControl error={error}>
            <RadioGroup
                defaultValue="date"
                value={value === 0 ? "unrestricted" : "date"}
                name="subscription_date_range-group"
                onChange={(event: any) => {
                    const ret = event.target.value === "unrestricted" ? 0 : consolidateDateToNumber(date);
                    onChange(ret);
                }}
            >
                <FormControlLabel
                    value="date"
                    control={<Radio />}
                    label={
                        <FormDateField
                            placeholder=""
                            disabled={value === 0}
                            value={date !== 0 ? mapNumberToDate(date).format(DATE_FORMAT) : today().format(DATE_FORMAT)}
                            onChange={(value: any) => {
                                setDate(consolidateDateToNumber(value));
                                onChange(consolidateDateToNumber(value));
                            }}
                            allowFuture
                            firstAvailableDate={mapNumberToDate(firstAvailableDate).format(DATE_FORMAT)}
                        />
                    }
                />
                <FormControlLabel value="unrestricted" control={<Radio />} label={label}/>
            </RadioGroup>
            <FormHelperText>{helperText}</FormHelperText>
        </FormControl>
    );
};

export const DateWithOptionEdit = withStyles(styles)(DateWithOptionEditPure);
